// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__KAfZi","item":"PaymentsMobile_item__1zmfM","label":"PaymentsMobile_label__2Dhhx","amount":"PaymentsMobile_amount__w13w2"};